import type { Schema } from '@cli-types/core-engine/schema.js'
import { toCamelCase, toPascalCase } from '@cli-utils/text.js'
import { renderSelectOptionsTableGeneratedValueTemplate } from '@next-adapter/templates/renderers/generators/database/generate-select-options-table.js'
import { getCreatableSelectFields } from './get-creatable-select-fields.js'

export function generateSelectOptionsTable(
  schema: Schema,
  requiredImports: Set<string>,
  needsSql: { value: boolean }
): string | null {
  const creatableSelectFields = getCreatableSelectFields(schema)
  if (creatableSelectFields.length === 0) {
    return null
  }

  const tableName = `${toPascalCase(schema.name)}SelectOptions`
  const variableName = `${toCamelCase(schema.name)}SelectOptions`
  const indexName = `${tableName}_fieldName_value_key`

  requiredImports.add('pgTable')
  requiredImports.add('text')
  requiredImports.add('timestamp')
  requiredImports.add('uniqueIndex')
  requiredImports.add('uuid')
  requiredImports.add('varchar')
  needsSql.value = true

  return renderSelectOptionsTableGeneratedValueTemplate({
    variableName: variableName,
    tableName: tableName,
    indexName: indexName
  })
}
